<p>
  Auf dieser Seite sind alle aktiven, passiven und Ehrenmitglieder zu finden. Über die Suche kann mittels Stammnummer, Vor- oder Nachnamen nach einem Mitglied gesucht werden. Rechts gibt es die Möglichkeit, nach Gruppen zu filtern und nur deren Mitglieder zu finden.<br />
  Nach dem Aufrufen eines Mitglieds ist es möglich, seine Kontaktdaten direkt als .vcf Datei herunterzuladen und diese in Outlook oder sonstige Kontaktverwaltungsprogramme zu laden.<br />
  Für Dienstgrade sind des Weiteren die Notfallkontakte des Mitglieds zu sehen.
</p>
